(function (doc, win) {
  var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function () {
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;

      if(clientWidth >= 1600){
        docEl.style.fontSize = 20 * (clientWidth / 1760) + 'px';
      }else if(clientWidth < 1600 && clientWidth >1366){
        docEl.style.fontSize = 20 * (clientWidth / 1440) + 'px';
      }else if(clientWidth >= 1080 && clientWidth <= 1366){
        docEl.style.fontSize = 20 * (clientWidth / 1280) + 'px';
      }else if(clientWidth >768 && clientWidth < 1080){
        docEl.style.fontSize = 20 * (clientWidth / 992) + 'px';
      }else if(clientWidth >=489 && clientWidth <= 768){
        docEl.style.fontSize = 20 * (clientWidth / 600) + 'px';
      }else if(clientWidth >=320 && clientWidth <= 488){
        docEl.style.fontSize = 20 * (clientWidth / 400) + 'px';
      }

      window.remSize = docEl.style.fontSize;
    };

  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);



// WEBPACK FOOTER //
// ./src/utils/rem.js